import * as Yup from 'yup';

export const menuSchema = Yup.object().shape({
    key: Yup.string()
        .max(100, 'Key must not exceed 100 characters')
        .required('Key is required'),
    name: Yup.string()
        .max(100, 'Name must not exceed 100 characters')
        .required('Name is required'),
    url: Yup.string()
        .max(100, 'URL must not exceed 100 characters')
        .required('URL is required'),
    isParent: Yup.boolean().required(),
    parentMenuId: Yup.string().nullable(),
    order: Yup.number()
        .typeError('Order must be a number')
        .required('Order is required'),
    isPrivileges: Yup.boolean().required(),
    isReviewer: Yup.boolean().required(),
});
